import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './approve.component.html',
  styleUrls: ['./approve.component.css'],
})
export class ApproveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
